import axios from "axios";

const BASE_URL = "https://app.duedil.com";

const headers = {
  Authorization:
    "Bearer uYfnPmN6Qw3Bq.sBctF6MBHGuij6D$bVCdbHq,;DxLvikQVLyRRXhxpsvrt)noXu"
};

// app.duedil.com/autocomplete/api/companies/
export const getCompanies = searchTerm =>
  axios({
    method: "GET",
    url: `${BASE_URL}/autocomplete/api/companies?name=${searchTerm}`,
    headers
  }).then(response => response.data);



// WEBPACK FOOTER //
// ./api/index.js